import React, { useContext, useState, useEffect } from "react";
import pClasses from "../Home.module.scss";
import UserTrainingContext from "../../../../context/userTrainingContext";
import Spinner from "../../../../components/Spinner";
import * as r from "../../../../constants/routes";
import { useNavigate } from "react-router";
import { prettySubPathUrl } from "../../../../helpers";
import SmartGameCard from "../../../../components/Cards/SmartGameCard";
import { GET_PROD_OR_DEV } from "../../../../constants/api";
import CardsArea from "../../../../components/Cards/CardsArea";
import PageMain from "../../../../components/Main/PageMain";
import * as a from "../../../../constants/api";
import SessionContext from "../../../../context/sessionContext";
import axios from "axios";
import heart from "../../../../assets/images/heart.png";
import brokenHeart from "../../../../assets/images/brokenHeart.png";
import Trails from "../../../../components/Trails";
import EndListScreen from "../EndListScreen";
import { useTranslation } from "react-i18next";
import RoundButton from "../../../../components/Buttons/RoundButton";

export default function TabTraining(_trails: any) {
  const tContext = useContext(UserTrainingContext);
  const history = useNavigate();
  const [isLoadingJump, setIsLoadingJumb] = useState(false);
  const [games, setGames] = useState([]);
  const [isLoadingGames, setIsLoadingGames] = useState(false);
  const [gamesStatus, setGamesStatus] = useState(0);
  const { t } = useTranslation();
  const { setGameUrl } = tContext ?? {};
  const cSession = useContext(SessionContext);
  const { user } = cSession ?? {};
  const [_content, setContent] = useState<any>(<Spinner center />);
  const getGames = () => {
    setIsLoadingGames(true);
    axios(a.API_GAMES, {
      headers: {
        userauthorization: user?.token,
      },
    })
      .then((response) => {
        setIsLoadingGames(true);
        setGames(response.data);
        setGamesStatus(1);
      })
      .catch((error) => {
        setIsLoadingGames(false);
        console.log(error);
        setGamesStatus(2);
      });
  };

  const buttonReload = (
    <div className={pClasses.gamesCards}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          paddingTop: "50px",
          alignItems: "center",
        }}
      >
        <div
          style={{
            textAlign: "center",
            marginBottom: "50px",
            paddingLeft: "15px",
            paddingRight: "15px",
          }}
        >
          Vamos continuar sua jornada! Clique no botão abaixo para recarregar a
          página e ter acesso ao treinamento!
        </div>
        <RoundButton
          title={"Recarregar página"}
          text={"Recarregar página"}
          onClick={() => window.location.reload()}
        />
      </div>
    </div>
  );
  useEffect(() => {
    getGames();
  }, []);
  useEffect(() => {
    if (!localStorage.getItem("hasReloadBeforeTests")) {
      localStorage.setItem("hasReloadBeforeTests", "false");
    }
  }, []);
  useEffect(() => {
    // Verifica se hasReloadBeforeTests do localStorage é false
    // if (games.length < 4) getGames();
    if (localStorage.getItem("hasReloadBeforeTests") === "false") {
      getGames();
      localStorage.setItem("hasReloadBeforeTests", "true");
    }
    if (games?.length) setGamesStatus(1);
    if (
      games.length === 0 &&
      (games?.length === 0 || games?.length === undefined)
    )
      setGamesStatus(2);
  }, []);

  const jumpProgress = (label_user_uid: any, user_uid: any) => {
    if (user) {
      setIsLoadingJumb(true);
      axios(a.API_USER_SKIP_PROGRESS, {
        data: {
          label_user_uid: label_user_uid,
          user_uid: user_uid,
        },
        method: "POST",
        headers: {
          userauthorization: user.token,
        },
      })
        .then((response) => {
          window.location.reload();
          setIsLoadingJumb(false);
        })
        .catch((error) => {
          console.log(error.data);
          setIsLoadingJumb(false);
        });
    }
  };

  const getGamesScreen = () => {
    const gamesArray: any = [];
    games?.map((game: any, i: number) => gamesArray.push(game));
    const hasLabels = gamesArray.some((obj: any) => "label" in obj);
    const _newGameList = (
      <div className={pClasses.gamesContainerAdjust}>
        <div className="row ">
          {gamesArray.length > 0 && hasLabels ? (
            gamesArray.map((game: any) => {
              const lives = game.lifes;
              const maxLives = 2;
              return (
                <>
                  <div
                    className={
                      pClasses.gamesCards + " col-xs-6 col-lg-6 col-sm-12"
                    }
                  >
                    <div className={pClasses.hearts}>
                      {" "}
                      Lives: {lives}{" "}
                      {lives > 0 &&
                        [
                          ...Array(
                            typeof lives === "string"
                              ? parseFloat(lives)
                              : lives
                          ),
                        ].map((e, i) => (
                          <span key={i}>
                            <img src={heart} />{" "}
                          </span>
                        ))}{" "}
                      {lives >= 0 &&
                        maxLives - lives >= 0 &&
                        [...Array(maxLives - lives)].map((e, i) => (
                          <span key={i}>
                            <img src={brokenHeart} />{" "}
                          </span>
                        ))}{" "}
                      - Trys: {game.try_number}
                    </div>
                    <SmartGameCard
                      key={game?.id ?? game?.name}
                      id={game?.id}
                      name={
                        game.name +
                        " - Nível: " +
                        game.nivel +
                        " " +
                        t("trilhas." + game.label)
                      }
                      image={game?.images.thumb}
                      abilities={game?.abilities}
                      isLoadingJump={isLoadingJump}
                      onClick={() => {
                        localStorage.setItem("hasOpenGame", "True");
                        history(
                          prettySubPathUrl(
                            r.GET_R_U_TRAIN_GAME_SCREEN("Memória", game.name)
                          )
                        );
                        setGameUrl(
                          game.activity_urls[GET_PROD_OR_DEV],
                          game.name
                        );
                      }}
                      showOnClickJump={game.try_number >= 3}
                      onClickJump={() => {
                        jumpProgress(game.label_user_uid, game.user_uid);
                      }}
                    />
                  </div>
                  <div className="col-xs-6 col-lg-6 col-sm-12 mt-3">
                    <Trails
                      game_list={
                        gamesArray[
                        gamesArray.findIndex(
                          (element: any) => element.label == game.label
                        )
                        ]
                      }
                    />
                  </div>
                </>
              );
            })
          ) : (
            <div className={pClasses.EndListScreen}>
              <EndListScreen />
            </div>
          )}
        </div>
      </div>
    );

    return (
      <>
        <CardsArea journeyCodeFour={!hasLabels}>{_newGameList}</CardsArea>
      </>
    );
  };
  useEffect(() => {
    switch (gamesStatus) {
      case 0:
        setContent(<Spinner center />);
        break;
      case 1:
        setContent(getGamesScreen());
        break;
      case 2:
        setContent(isLoadingGames ? <Spinner center /> : buttonReload);
        break;
      default:
        setContent(<Spinner center />);
        break;
    }
  }, [games, gamesStatus, isLoadingGames]);

  return (
    <PageMain centerStretch className={pClasses.TabSmartTraining}>
      <section>{_content}</section>
    </PageMain>
  );
}
